import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'ssGroupByFields', pure: false })
export class SavedSearchGroupByFieldsPipe implements PipeTransform {
    transform(groupFields: Array<any>, selectedField: any): any[] {
        if (groupFields && groupFields.length && selectedField?.field) {
            return groupFields.filter(gField=> gField?.field!=selectedField?.field);
        } else {
            return groupFields;
        }
    }
}
